import { cva } from "class-variance-authority";
import type { TranslationFn } from "../types";

export const pinInfoVariants = cva(
  "relative left-[-88px] top-[-123px] z-10 flex flex-col items-center rounded p-[8px]",
  {
    variants: {
      variant: {
        confirmAddress:
          "left-[-58px] top-[-110px] min-h-[48px] w-[180px] rounded-lg bg-black text-center",
        supported: "h-[48px] w-[230px] bg-black",
        unsupported: "top-[-150px] h-[76px] w-[230px] bg-red-400",
      },
    },
    defaultVariants: {
      variant: "supported",
    },
  },
);

export const getMainText = (
  isAreaSupported: boolean,
  isConfirmAddress: boolean | undefined,
  t: TranslationFn,
): string => {
  if (isConfirmAddress) return t("addressJourney.addressForm.area");
  if (isAreaSupported) return t("addressJourney.yourOrderWillBeDeliveredHere");
  return t("addressJourney.outOfService");
};

export const getSubText = (
  emirate: string | undefined,
  town: string | undefined,
  isAreaSupported: boolean,
  isConfirmAddress: boolean | undefined,
  t: TranslationFn,
): string => {
  if (isConfirmAddress && emirate) return emirate;
  if (isConfirmAddress && town) return town;
  if (isAreaSupported) return t("addressJourney.dragPin");
  return t("addressJourney.pleaseTryAnotherLocation");
};

export const getVariant = (
  isAreaSupported: boolean,
  isConfirmAddress: boolean | undefined,
): "confirmAddress" | "supported" | "unsupported" => {
  if (isConfirmAddress) return "confirmAddress";
  if (isAreaSupported) return "supported";
  return "unsupported";
};
